export enum POOL_DETAIL_TABS {
  PRICE = 'Price',
  VOLUME = 'Volume',
  LIQUIDITY = 'Liquidity',
  FEES = 'Fees',
}
